import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Text,
  Table,
  Tbody,
  Td,
  Tr,
  Thead,
  Th,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Flex,
  Input,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast,
  Badge,
  useColorModeValue,
  Heading,
} from '@chakra-ui/react';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Course, Term, PlannedClass } from "../Common/types";
import LessonsTable from '../Components/LessonsTable';
import { FiEdit, FiTrash, FiCheck, FiX } from "react-icons/fi";

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;
  role_id: number;
  tenant_id: number;
  exp?: number;
}

const ReviewCourseTerms = () => {
  const [course, setCourse] = useState<Course>();
  const [newTermTitle, setNewTermTitle] = useState<string>(""); // Initialize with an empty string
  const [terms, setTerms] = useState<Term[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const [selectedTerm, setSelectedTerm] = useState<Term | null>(null);

  const [selectedTermClasses, setSelectedTermClasses] = useState<PlannedClass[] | null>(null);

  const [selectedClass, setSelectedClass] = useState<PlannedClass | null>(null);

  const [newTitle, setNewTitle] = useState("");

  const [newClassTitle, setNewClassTitle] = useState<string>(""); // Initialize with an empty string
  const [newClassDesciption, setNewClassDescription] = useState<string>(""); // Initialize with an empty string


  const { isOpen, onOpen, onClose } = useDisclosure(); // Modal controls

  const { course_id } = useParams<{ course_id: string }>();
  const toast = useToast();

  const buttonBg = useColorModeValue(
    'linear-gradient(to right, blue.50, blue.100)',
    'linear-gradient(to right, blue.600, blue.700)'
  );

  const courseBg = useColorModeValue(
    'purple.50',
    'purple.800'
  );


  const buttonBg1 = useColorModeValue(
    'linear-gradient(to right, cyan.50, cyan.100)',
    'linear-gradient(to right, cyan.600, cyan.700)'
  );
  const buttonHoverBg = useColorModeValue(
    'blue.200',
    'blue.500'
  );

  const buttonHoverBg1 = useColorModeValue(
    'cyan.200',
    'cyan.500'
  );


  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isClassNewOpen,
    onOpen: onClassNewOpen,
    onClose: onClassNewClose,
  } = useDisclosure();
  const {
    isOpen: isClassEditOpen,
    onOpen: onClassEditOpen,
    onClose: onClassEditClose,
  } = useDisclosure();
  const {
    isOpen: isClassDeleteOpen,
    onOpen: onClassDeleteOpen,
    onClose: onClassDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isLessonNewOpen,
    onOpen: onLessonNewOpen,
    onClose: onLessonNewClose,
  } = useDisclosure();
  const {
    isOpen: isLessonEditOpen,
    onOpen: onLessonEditOpen,
    onClose: onLessonEditClose,
  } = useDisclosure();
  const {
    isOpen: isLessonDeleteOpen,
    onOpen: onLessonDeleteOpen,
    onClose: onLessonDeleteClose,
  } = useDisclosure();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  // Fetch course details
  useEffect(() => {
    if (course_id) {
      
      fetchCourse();
      fetchTerms();
     // fetchSelectedTermClasses();
    }
  }, [course_id]);



  const fetchCourse = async () => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.get(apiurl + `/courses/${course_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setCourse(response.data);
    } catch (error) {
      console.error("Failed to load Course", error);
    }
  };

  const fetchTerms = async () => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.get(apiurl + `/courses/${course_id}/terms`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setTerms(response.data);
    } catch (error) {
      console.error("Failed to load terms of the course", error);
    }
  };

  const fetchSelectedTermClasses = async (term_id : number) => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      
    const response = await axios.get(apiurl + `/terms/${term_id}/planned-classes`, {
        headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });
    setSelectedTermClasses(response.data);
        
    } catch (error) {
      console.error("Failed to load terms of the course", error);
    }
  };


  const handleEditConfirm = async () => {
    if (selectedTerm) {
      try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        await axios.put(
          `${apiurl}/terms/${selectedTerm.id}`,
          { title: newTitle,
            course_id:selectedTerm.course_id,
            sequence_number:selectedTerm.sequence_number,
           },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        setTerms((prevTerms) =>
          prevTerms.map((term) =>
            term.id === selectedTerm.id ? { ...term, title: newTitle } : term
          )
        );
        toast({
          title: "Term updated successfully!",
          status: "success",
          duration: 3000,
        });
        onEditClose();
      } catch (error) {
        toast({
          title: "Failed to update term.",
          status: "error",
          duration: 3000,
        });
      }
    }
  };

// Handle delete modal actions
const handleDeleteClick = (term: Term) => {
setSelectedTerm(term);

  // Find the index of the term being deleted
  const index = terms.findIndex((myterm) => myterm.id === term.id);

  // Check if it's the last term
  if (index === terms.length - 1) {
    onDeleteOpen();
  } 
  else
  {
    toast({
      title: "Only last term can be deleted.",
      status: "error",
      duration: 3000,
    });
  }
};

// Handle edit modal actions
const handleEditClick = (term: Term) => {
    setSelectedTerm(term);
    setNewTitle(term.title);
    onEditOpen();
    };

// Handle edit modal actions
const handleClassOpenClick = (term: Term) => {
console.log("Selected Term from Handler", term.title);
setSelectedTerm(term);
setNewTitle(term.title);
setNewClassTitle("");
setNewClassDescription("");
onClassNewOpen();
};

const handleAccordionChange = (term_id: number) => {
fetchSelectedTermClasses(term_id);
};

 
  const handleDeleteConfirm = async () => {
    if (selectedTerm) {
      try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        await axios.delete(`${apiurl}/terms/${selectedTerm.id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        // Update terms state
      setTerms((prevTerms) => {
        const updatedTerms = prevTerms.filter((term) => term.id !== selectedTerm.id);

        // Determine the next term to open
        if (updatedTerms.length > 0) {
          const nextTerm = updatedTerms[0]; // Adjust logic here if needed
          fetchSelectedTermClasses(nextTerm.id);
          setSelectedTerm(nextTerm); // Set the next term as selected
        } else {
          setSelectedTerm(null); // No terms left
          setSelectedTermClasses(null);
         // setSelectedTermClasses(null); // Clear planned classes
        }

        return updatedTerms; // Return updated terms for state
      });
        toast({
          title: "Term deleted successfully!",
          status: "success",
          duration: 3000,
        });
        onDeleteClose();
      } catch (error) {
        toast({
          title: "Failed to delete term.",
          status: "error",
          duration: 3000,
        });
      }
    }
  };

  const handleAddNewTerm = async () => {
    if (!newTermTitle) {
      toast({
        title: "Error",
        description: "Please enter a title for the new term.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
      const response = await axios.post(
        `${apiurl}/courses/${course_id}/terms`,
        { title: newTermTitle, 
          sequence_number:terms.length+1,
          course_id:course_id,
        }, // API expects title
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast({
        title: "Term Added",
        description: "The new term was successfully created.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setNewTermTitle(""); // Reset the input field
      fetchTerms();
      onClose(); // Close the modal
      // Optionally, refresh terms list
    } catch (error) {
      console.error("Failed to add new term", error);
      toast({
        title: "Error",
        description: "Failed to add new term.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    }

    const handleAddNewClass = async () => {
        console.log("New Class Title", newClassTitle);
        if (!newClassTitle) {
          toast({
            title: "Error",
            description: "Please enter a title for the new class.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
        console.log("Selected Term",selectedTerm?.title)
        if(selectedTerm)
        {
                try {
                const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
                const response = await axios.post(
                    `${apiurl}/terms/${selectedTerm.id}/planned-classes`,
                    { title: newClassTitle,
                    description: newClassDesciption, 
                    sequence_number: (selectedTermClasses?.length || 0) + 1,

                    term_id:selectedTerm.id,
                    }, // API expects title
                    {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    }
                );
                toast({
                    title: "Planned Class Added",
                    description: "The new planned class was successfully created.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                setNewClassTitle(""); // Reset the input field
                setNewClassDescription(""); // Reset the input field
                fetchSelectedTermClasses(selectedTerm.id);
                onClassNewClose();
                // Optionally, refresh terms list
                } catch (error) {
                console.error("Failed to add new class", error);
                toast({
                    title: "Error",
                    description: "Failed to add new class.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                }
            }
        }


        // Handle delete modal actions
const handleClassDeleteClick = (termclass:PlannedClass) => {
    setSelectedClass(termclass);
   

      if(selectedTermClasses)
      {
          // Find the index of the term being deleted
        const index = selectedTermClasses.findIndex((mytermclass) => mytermclass.id === termclass.id);

        // Check if it's the last term
        if (index === selectedTermClasses.length - 1) {
          onClassDeleteOpen();
        } 
        else
        {
          toast({
            title: "Only last Planned Class can be deleted.",
            status: "error",
            duration: 3000,
          });
        }
      }

    };
    
    // Handle edit modal actions
    const handleClassEditClick = (termclass:PlannedClass) => {
        setSelectedClass(termclass);
        setNewClassTitle(termclass.title);
        setNewClassDescription(termclass.description ?? "");
        onClassEditOpen();
        };

        const handleClassDeleteConfirm = async () => {
            
            if (selectedClass) {
              try {
                const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
                await axios.delete(`${apiurl}/planned-classes/${selectedClass.id}`, {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
                });
                setSelectedTermClasses((prevSelectedTermClasses) =>
                    prevSelectedTermClasses
                      ? prevSelectedTermClasses.filter((plannedClass) => plannedClass.id !== selectedClass.id)
                      : null
                  );
                  toast({
                  title: "Term deleted successfully!",
                  status: "success",
                  duration: 3000,
                });
                onClassDeleteClose();
              } catch (error) {
                toast({
                  title: "Failed to delete term.",
                  status: "error",
                  duration: 3000,
                });
              }
            }
          };

          const handleClassEditConfirm = async () => {
            if (selectedClass) {
              try {
                const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
                await axios.put(
                  `${apiurl}/planned-classes/${selectedClass.id}`,
                  {
                    title: newClassTitle,
                    description: newClassDesciption,
                    term_id: selectedClass.term_id,
                    sequence_number: selectedClass.sequence_number,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                  }
                );
          
                setSelectedTermClasses((prevSelectedTermClasses) =>
                    prevSelectedTermClasses
                      ? prevSelectedTermClasses.map((plannedClass) =>
                          plannedClass.id === selectedClass.id
                            ? { ...plannedClass, title: newClassTitle, description: newClassDesciption }
                            : plannedClass
                        )
                      : null
                  );
                  
          
                toast({
                  title: "Class updated successfully!",
                  status: "success",
                  duration: 3000,
                });
          
                onClassEditClose();
              } catch (error) {
                toast({
                  title: "Failed to update class.",
                  status: "error",
                  duration: 3000,
                });
              }
            }
          };
          

  if (!course_id) {
    return <p>Loading course term planned classes and lesson details...</p>;
  }
  if (!course?.is_active) {
    return (
      <Box >
      <Box p={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm" mb={4} position="relative">
          <Heading size={"md"}>
            Course # {course?.id} - {course?.title}
          </Heading>
          <Text>{course?.description}</Text>
          <Badge
            colorScheme={"red"}
            position="absolute"
            top={2}
            right={2}
            borderRadius="md"
            px={3}
            py={1}
          >
            {course?.is_active ? "Active" : "Inactive"}
          </Badge>
          <Text>To make edits to the course, you need to first make it Active.</Text>
        </Box>
        </Box>

    );
  }

  return (
    <Box as="main" mx="auto" p={10} >
      <Box p={4} bgColor={courseBg}  boxShadow="sm"  borderWidth={1} borderRadius="sm" mb={4} position="relative">
            <Heading size={"md"}>
              Course # {course?.id} - {course?.title}
            </Heading>
            <Text>{course?.description}</Text>
            <Badge
              colorScheme={course?.is_active ? "green" : "red"}
              position="absolute"
              top={2}
              right={2}
              borderRadius="md"
              px={3}
              py={1}
            >
              {course?.is_active ? "Active" : "Inactive"}
            </Badge>
      </Box>
  
      <Box mt={4}>
        <Button colorScheme="blue" borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={onOpen} >
          + Term
        </Button>
      </Box>
      <Accordion allowToggle mt={1} >
        {terms.map((term) => (
          <AccordionItem key={term.id} >
            <h2>
              <AccordionButton
                  onClick={() => handleAccordionChange(term.id)}
                  height="50px"
                  backgroundImage={buttonBg} // Use backgroundImage for gradients
                  _hover={{ bg: buttonHoverBg }}
                  borderRadius="sm"
                  mt={2}
                >
                <Box flex="1" textAlign="left" fontSize={"lg"} fontWeight={"bold"}>
                 # {term.sequence_number} {term.title}
                </Box>
              </AccordionButton>
            </h2>
            <AccordionPanel p={0}>
            
                <Box borderRadius={"sm"} borderColor={"gray.300"} borderWidth={1} m={0} mt={1} mb={1}>
                    {term ? (
                    <Table variant="simple" size="sm" >
                       <Thead>
                          <Tr backgroundImage={buttonBg}>
                            <Th>ID</Th>
                            <Th>Title</Th>
                            <Th>Sequence No.</Th>
                            <Th>Actions</Th>
                          </Tr>
                        </Thead>
                        <Tbody  >
                        <Tr>
                            
                            <Td>{term.id}</Td>
                            <Td>{term.title}</Td>
                            <Td>{term.sequence_number.toString()}</Td>
                            <Td>
                        <Button size="sm" colorScheme="blue" onClick={() => handleEditClick(term)} mr={8}>
                        <FiEdit />
                            </Button>   
                            <Button size="sm" colorScheme="red" onClick={() => handleDeleteClick(term)}>
                            <FiTrash />
                            </Button>
                            </Td>
                        </Tr>
                        </Tbody>
                    </Table>
                    ) : (
                    <Text>Loading metadata...</Text>
                    )}
                </Box>
                <Box borderRadius={"sm"} borderColor={"gray.300"} borderWidth={1} m={0}>
                <Box m={2}>
                        {/* Add the code for Planned Class Accordion with buttons to Up or Down the sequence */}
                        {/* <Button borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={onClassNewOpen} > */}
                        <Button colorScheme="cyan" borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={() => handleClassOpenClick(term)} >
                        + Planned Class
                        </Button>

                        <Accordion allowToggle>
                        {selectedTermClasses?.map((termclass) => (
                        <AccordionItem key={termclass.id}>
                            <h2>
                            <AccordionButton   height="40px"
                  backgroundImage={buttonBg1} // Use backgroundImage for gradients
                  _hover={{ bg: buttonHoverBg1 }}
                  borderRadius="sm"
                  mt={1}>
                                <Box flex="1" fontSize={"sm"} textAlign="left">
                                # {termclass.sequence_number} {termclass.title}
                                </Box>
                            </AccordionButton>
                            </h2>
                            <AccordionPanel p={0}>

                              <Box borderRadius={"sm"} borderColor={"blue.200"} borderWidth={1} m={0} mt={1} mb={1}>
                                {termclass ? (
                                <Table variant="simple" size="sm" mb={2}>
                                   <Thead>
                                      <Tr backgroundImage={buttonBg1}>
                                        <Th>ID</Th>
                                        <Th>Title</Th>
                                        <Th>Description</Th>
                                        <Th>Sequence No.</Th>
                                        <Th>Actions</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                    <Tr>
                                     
                                        <Td>{termclass.id}</Td>
                                        
                                        <Td>{termclass.title}</Td>
                          
                                        <Td>{termclass.description}</Td>
                          
                                        <Td>{termclass.sequence_number.toString()}</Td>
                                 
                                  <Td>          
                                    <Button size="sm" colorScheme="blue" onClick={() => handleClassEditClick(termclass)} mr={8} >
                                    <FiEdit />
                                    </Button>
                                    <Button size="sm" colorScheme="red" onClick={() => handleClassDeleteClick(termclass)}>
                                    <FiTrash />
                                    </Button>
                                    </Td>
                                    </Tr>
                                    </Tbody>
                                </Table>
                                ) : (
                                <Text>Loading metadata...</Text>
                                )}
                            </Box>
                            <Box borderRadius={"sm"} borderColor={"blue.200"} borderWidth={1} m={0} mt={1} mb={1} p={2}>
                            <LessonsTable plannedClassId={termclass.id}/>
                            </Box>
                            </AccordionPanel>
                        </AccordionItem>
                       )) || <p>No planned classes available.</p>}
                    </Accordion>
                    </Box>
                </Box>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>

       {/* Modal for adding a new term */}
       <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create a New Term</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Enter new term title"
              value={newTermTitle}
              onChange={(e) => setNewTermTitle(e.target.value)}
            />
            <Box mt={2} fontSize="sm" color="gray.600">
              The term will be created last in the existing sequence.
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              onClick={handleAddNewTerm}
              isDisabled={!newTermTitle.trim()}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

 {/* Edit Modal */}
<Modal isOpen={isEditOpen} onClose={onEditClose}>
  <ModalOverlay />
  <ModalContent maxWidth="500px"> {/* Adjust modal width */}
    <ModalHeader>Edit Term</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <Box display="flex" alignItems="center" mb={4}>
        <Text fontWeight="bold" minWidth="150px" whiteSpace="nowrap" mr={3}>
          Enter New Term Title:
        </Text>
        <Input
          flex="1"
          placeholder="Enter new title"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </Box>
      <Text fontSize="sm" color="gray.500">
        Only Title can be edited, sequence number cannot be changed.
      </Text>
    </ModalBody>
    <ModalFooter>
      <Button colorScheme="blue" mr={3} onClick={handleEditConfirm}>
        Save
      </Button>
      <Button variant="ghost" onClick={onEditClose}>
        Cancel
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>


      {/* Delete Modal */}
      <Modal isOpen={isDeleteOpen} onClose={onDeleteClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Term</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete this term? This action cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={handleDeleteConfirm}  mr={3}>
              Delete
            </Button>
            <Button onClick={onDeleteClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>



      {/* Modal for adding a new Planned Class */}
      <Modal isOpen={isClassNewOpen} onClose={onClassNewClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create a New Planned Class</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Enter new Planned Class Title"
              value={newClassTitle}
              onChange={(e) => setNewClassTitle(e.target.value)}
            />
            <Input mt={2}
              placeholder="Enter new Planned Class Description"
              value={newClassDesciption}
              onChange={(e) => setNewClassDescription(e.target.value)}
            />
            <Box mt={2} fontSize="sm" color="gray.600">
              The Planned Class will be created last in the existing sequence.
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClassNewClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              onClick={handleAddNewClass}
              isDisabled={!newClassTitle.trim()}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

 {/* Edit Modal */}
<Modal isOpen={isClassEditOpen} onClose={onClassEditClose}>
  <ModalOverlay />
  <ModalContent maxWidth="500px"> {/* Adjust modal width */}
    <ModalHeader>Edit Term</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <Box display="flex" alignItems="center" mb={4}>
        <Text fontWeight="bold" minWidth="150px" whiteSpace="nowrap" mr={3}>
          Enter New Class Title:
        </Text>
        <Input
          flex="1"
          placeholder="Enter new Class Title"
          value={newClassTitle}
          onChange={(e) => setNewClassTitle(e.target.value)}
        />
         </Box>
      <Box display="flex" alignItems="center" mb={4}>
        <Text fontWeight="bold" minWidth="150px" whiteSpace="nowrap" mr={3}>
          Enter New Class Desc.:
        </Text>
        <Input
          flex="1"
          placeholder="Enter new Class Description"
          value={newClassDesciption}
          onChange={(e) => setNewClassDescription(e.target.value)}
        />
        </Box>
     
      <Text fontSize="sm" color="gray.500">
        Only Title can be edited, sequence number cannot be changed.
      </Text>
    </ModalBody>
    <ModalFooter>
      <Button colorScheme="blue" mr={3} onClick={handleClassEditConfirm}>
        Save
      </Button>
      <Button variant="ghost" onClick={onClassEditClose}>
        Cancel
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>


      {/* Delete Modal */}
      <Modal isOpen={isClassDeleteOpen} onClose={onClassDeleteClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Planned Class</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to delete this Planned Class? This action cannot be undone.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={handleClassDeleteConfirm}  mr={3}>
              Delete
            </Button>
            <Button onClick={onClassDeleteClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
</Box>
  );
};

export default ReviewCourseTerms;
